module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "lxm-close-notification"
  }, [_c('a', {
    staticClass: "lxm-close-notification__button button",
    class: {
      'lxm-close-notification__button--highlight': _vm.highlight, 'is-loading': _vm.loading
    },
    on: {
      "click": _vm.clicked
    }
  }, [(_vm.open) ? [(_vm.highlight) ? _c('img', {
    staticClass: "lxm-close-notification__icon",
    attrs: {
      "src": require("../../images/main/close.png")
    }
  }) : _c('img', {
    staticClass: "lxm-close-notification__icon",
    attrs: {
      "src": require("../../images/main/close-white.png")
    }
  }), _vm._v("\n        关闭本项目新消息提醒\n      ")] : [(!_vm.loading) ? [(_vm.highlight) ? _c('img', {
    staticClass: "lxm-close-notification__icon",
    attrs: {
      "src": require("../../images/main/cf/success.png")
    }
  }) : _vm._e()] : _vm._e(), _vm._v("\n        开启本项目新消息提醒\n      ")]], 2)]), _vm._v(" "), _c('div', {
    staticClass: "lxm-close-notification-placeholder"
  })])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-97d2a55c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-97d2a55c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Main/common/LxmCloseNotification.vue
// module id = 881
// module chunks = 0